import { emptyArray } from 'ui-components/default-props/empty';
import * as NavActions from '../../../store/shipments/nav/shipments.nav.actions';

import * as Actions from './shipments.selected-shipments.actions';

const initialState = {
  selectedShipmentIds: emptyArray,
};

export const reduce = (state = initialState, { selectedShipmentIds, type }) => {
  switch (type) {
    case Actions.SET_SELECTED_SHIPMENTS:
      return {
        ...state,
        selectedShipmentIds,
      };
    case NavActions.SHIPMENTS_CHANGE_VIEW:
    case Actions.CLEAR_SELECTED_SHIPMENTS:
      return {
        ...state,
        selectedShipmentIds: emptyArray,
      };
    default:
      return state;
  }
};

export { namespace } from './shipments.selected-shipments.reducer.metadata';
